<template>
  <div class="crm-main-cont">
    <div class="search-box">
      <a-form :form="formSearch">
        <a-form-item label="联络人" v-bind="layoutStyle2">
          <a-input v-decorator="['name']"/>
        </a-form-item>
        <a-form-item label="手机号" v-bind="layoutStyle2">
          <a-input v-decorator="['mobile']"/>
        </a-form-item>
        <a-form-item label="金融机构" v-bind="layoutStyle2">
          <a-input v-decorator="['dept']"/>
        </a-form-item>
        <!--                <a-form-item label="账号类型" v-bind="layoutStyle2">
                            <a-select
                                    v-decorator="['userType',{initialValue:''}]"
                                    placeholder="请选择账号类型"
                            >
                                <a-select-option value="">全部</a-select-option>
                                <a-select-option :value="1" >机构管理员</a-select-option>
                                <a-select-option :value="2" >分支机构用户</a-select-option>
                            </a-select>
                        </a-form-item>-->
        <a-form-item label="状态" v-bind="layoutStyle2">
          <a-select v-decorator="['userStatus',{initialValue:''}]">
            <a-select-option value="">
              全部
            </a-select-option>
            <a-select-option :value="1">
              启用
            </a-select-option>
            <a-select-option :value="0">
              禁用
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </div>
    <div class="btns-group">
      <a-button type="primary" @click="handleSearch">
        搜索
      </a-button>
      <a-button @click="handleReset">
        重置
      </a-button>
      <a-button @click="addAccount" type="primary">
        添加用户
      </a-button>
    </div>

    <a-table
        class="unitUser-list"
        :columns="columns"
        :dataSource="yxdwUserList"
        @change="handleTableChange"
        bordered
        rowKey="id"
        :pagination="pagination"
    >
      <template slot="userType" slot-scope="text">
        {{ text === '1' ? "机构管理员" : "分支机构用户" }}
      </template>
      <template slot="userStatus" slot-scope="text">
        {{ text === '1' ? "启用" : "禁用" }}
      </template>
      <template slot="auth" slot-scope="text, record">
        <a @click="() => showAuth(record)">查看</a>
      </template>
      <template slot="operation" slot-scope="text, record">
        <div class="editable-row-operations">
          <a v-show="record.userStatus === '1'"
             @click="() => edit(record)">修改</a>
          <a
              v-show="record.userStatus === '0'"
              @click="() => start(record.id)"
          >启用</a
          >
          <a
              v-show="record.userStatus === '1'"
              @click="() => stop(record.id)"
          >禁用</a
          >
          <a
              v-show="record.userStatus === '1'"
              @click="() => resetPass(record.mobile)"
          >重置密码</a
          >
        </div>
      </template>
    </a-table>

    <a-drawer
        :title="title"
        :width="650"
        @close="onClose"
        :visible="visible"
    >
      <a-form v-if="!editStatus && visible" :form="form" layout="vertical">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item label="联络员">
              <a-input
                  v-decorator="[
                                    'name',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请填写联络员!'
                                            },
											{
												min:2,
												max:20,
												message: '联络员必须输入2-20字符范围内'
											}
                                        ]
                                    }
                                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="手机号码">
              <a-input
                  :maxLength=11
                  v-decorator="[
                                    'mobile',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请填写手机号码!'
                                            },{
                                                validator: comparePhone,
                                            }
                                        ]
                                    }
                                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item label="所属金融机构">
              <a-select
                  v-decorator="[
                                    'yxdwId',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请选择所属金融机构'
                                            }
                                        ]
                                    }
                                ]"
              >
                <a-select-option
                    :key="org.id"
                    v-for="org in organizationList"
                    :value="org.id"
                >{{ org.full_name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="所属部门">
              <a-input
                  v-decorator="[
                                    'dept',{
										rules: [
										    {

										    },
											{
												min:2,
												max:20,
												message:'所属部门的输入范围在2-20字符范围内的内容'
											}
										]
									}

                                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item label="用户类型">
              <a-select
                  v-decorator="[
                                    'userType',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请选择用户类型!'
                                            }
                                        ]
                                    }
                                   ]"
                  placeholder="请选择类型"
              >
                <a-select-option value="1">
                  机构管理员
                </a-select-option>
                <!--                                <a-select-option value="2">
                                                    分支机构用户
                                                </a-select-option>-->
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="所属区域">
              <a-select
                  v-decorator="[
                                    'region',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请选择所属区域'
                                            }
                                        ]
                                    }
                                   ]"
                  placeholder="请选择所属区域"
              >
                <a-select-option v-for="item in regionMark" :key="item.param">
                  {{item.desc}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item label="职务">
              <a-input
                  v-decorator="[
                                    'station',
									{
										rules: [
											{

											},
											{
												min:2,
												max:50,
												message:'职务的输入范围在2-20字符范围内的内容'
											}
										]
									}
                                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="性别">
              <a-select
                  v-decorator="[
                                    'sex',
                                    {

                                    }
                                   ]"
                  placeholder="请选择性别"
              >
                <a-select-option value="男">
                  男
                </a-select-option>
                <a-select-option value="女">
                  女
                </a-select-option>
              </a-select>

            </a-form-item>
          </a-col>
        </a-row>

        <div class="submit-btn">
          <a-button @click="handleSubmit" type="primary"
          >提交
          </a-button
          >
        </div>
      </a-form>
      <a-form v-if="editStatus && visible" :form="form2">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item label="姓名">
              <a-input
                  v-decorator="[
                                    'name',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '姓名为必填项!'
                                            },
											{
												min:2,
												max:50,
												message:'姓名的输入范围在2-50个字符范围内'
											}
                                        ]
                                    }
                                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="手机号码">
              <a-input disabled
                       v-decorator="[
                                    'mobile',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请填写手机号码!'
                                            }
                                        ]
                                    }
                                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item label="所属金融机构">
              <a-select
                  v-decorator="[
                                    'yxdwId',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请选择所属金融机构'
                                            }
                                        ]
                                    }
                                ]"
              >
                <a-select-option
                    :key="org.id"
                    v-for="org in organizationList"
                    :value="org.id"
                >{{ org.full_name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="所属部门">
              <a-input
                  v-decorator="[
                                    'dept',{
										rules: [
											{

											},
											{
												min:2,
												max:20,
												message:'所属部门的输入范围在2-20字符范围内的内容'
											}
										]
									}

                                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item label="用户类型">
              <a-select
                  v-decorator="[
                                    'userType',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请选择用户类型!'
                                            }
                                        ]
                                    }
                                   ]"
                  placeholder="请选择类型"
              >
                <a-select-option value="1">
                  单位管理员
                </a-select-option>
                <!--                                <a-select-option value="2">
                                                    普通工作人员
                                                </a-select-option>-->
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="所属区域">
              <a-select
                  v-decorator="[
                                    'region',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请选择所属区域'
                                            }
                                        ]
                                    }
                                   ]"
                  placeholder="请选择所属区域"
              >
                <a-select-option v-for="item in regionMark" :key="item.param">
                  {{item.desc}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item label="职务">
              <a-input
                  v-decorator="[
                                    'station',{
										rules: [
											{

											},
											{
												min:2,
												max:20,
												message:'职务的输入范围在2-20字符范围内的内容'
											}
										]
									}

                                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="性别">
              <a-select
                  v-decorator="[
                                    'sex',
                                    {

                                    }
                                   ]"
                  placeholder="请选择性别"
              >
                <a-select-option value="男">
                  男
                </a-select-option>
                <a-select-option value="女">
                  女
                </a-select-option>
              </a-select>

            </a-form-item>
          </a-col>

        </a-row>

        <div class="submit-btn">
          <a-button @click="updateYxdwUser" type="primary"
          >修改
          </a-button
          >
        </div>
      </a-form>
    </a-drawer>

  </div>
</template>

<script>
import {
  getUnitUserList,
  addYxdwUser,
  updateYxdwUser,
  disableYxdwUser,
  enableYxdwUser,
  resetPassword
} from "@/api/operate/unituser";
import {findYxdwList, getTypes} from "@/api/operate/employer";
import axios from "axios";
import qs from "qs";
import {api} from "@/plugins/util";

const columns = [
  {
    title: "姓名",
    dataIndex: "name",
    scopedSlots: {customRender: "name"},
    width: 110,
  },

  {
    title: "手机号",
    dataIndex: "mobile",
    scopedSlots: {customRender: "mobile"},
    width: 90,
  },


  {
    title: "所属金融机构",
    dataIndex: "yxdw",
    scopedSlots: {customRender: "yxdw"},
    width: 200,
  },
  {
    title: "所属部门",
    dataIndex: "dept",
    scopedSlots: {customRender: "dept"},
    width: 110,
  },
  {
    title: "职务",
    dataIndex: "station",
    scopedSlots: {customRender: "station"},
    width: 130,
  },
  /*        {
              title: "用户类型",
              dataIndex: "userType",
              scopedSlots: { customRender: "userType" },
              width: 110,
          },*/
  {
    title: "状态",
    dataIndex: "userStatus",
    scopedSlots: {customRender: "userStatus"},
    width: 70,
  },
  {
    title: "操作",
    dataIndex: "operation",
    scopedSlots: {customRender: "operation"},
    width: 150,
  }
];
export default {
  data() {
    return {
      columns,
      deptment: "",
      form: this.$form.createForm(this),
      form2: this.$form.createForm(this),
      formSearch: this.$form.createForm(this),
      editStatus: false,
      visible: false,
      organizationList: [],
      regionMark:[],
      title: "添加机构用户",
      layoutStyle: {
        labelCol: {
          span: 7
        },
        wrapperCol: {
          span: 16
        }
      },
      layoutStyle2: {
        labelCol: {
          span: 7
        },
        wrapperCol: {
          span: 17
        }
      },
      yxdwUserList: [],
      search: {
        name: "",
        mobile: "",
        userType: 1,
        dept: "",
        userStatus: "",
        pageNum: ""
      },
      pagination: {
        total: 40,
        current: 1,
        pageSize: 20
      },
      editItem: "",
      authVisible: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    getUnitUserList({
      name: "",
      mobile: "",
      userType: 1,
      userStatus: "",
      pageNum: ""
    })
        .then(res => {
          next(vm => {
            vm.$ajaxAfter(res).then(() => {
              vm.getQyType();
              vm.pagination = {
                current: res.data.data.page.pageNum,
                total: res.data.data.page.total,
                pageSize: res.data.data.page.pageSize
              };
              vm.yxdwUserList = res.data.data.page.list;
              //vm.deptment = res.data.data.account.department;

            });
          });
        })
        .catch(() => {
          next(vm => {
            vm.$message.error("服务器出错！请稍后再试!");
            vm.$Progress.fail();
          });
        });

  },
  mounted() {


  },
  methods: {
    //点击搜索
    handleSearch() {
      let values = this.formSearch.getFieldsValue();
      Object.assign(this.search, {
        name: values.name || "",
        mobile: values.mobile || "",
        dept: values.dept || "",
        userStatus: values.userStatus,
        pageNum: 1
      });
      this.initYxdwUserList();
    },
    //点击重置
    handleReset() {
      this.formSearch.resetFields();
      Object.assign(this.search, {
        name: "",
        mobile: "",
        userType: 1,
        dept: "",
        userStatus: "",
        pageNum: 1
      });
      this.initYxdwUserList();
    },
    //初始化用户数据
    initYxdwUserList() {
      getUnitUserList(this.search)
          .then(res => {
            this.$ajaxAfter(res).then(() => {
              this.yxdwUserList = res.data.data.page.list;
              //this.deptment = res.data.data.account.department;
              Object.assign(this.pagination, {
                total: res.data.data.page.total,
                pageSize: res.data.data.page.pageSize,
                current: res.data.data.page.pageNum
              });
            });
          })
          .catch(() => {
            this.$message.error("服务器出错！请稍后再试!");
          });
    },
    addAccount() {
      findYxdwList()
          .then(res => {
                this.$ajaxAfter(res).then(() => {
                  this.organizationList = res.data.data.list
                })
              }
          );
      this.title = "添加机构用户";
      this.editStatus = false;
      this.visible = true;
    },
    //获取单位列表数据
    onClose() {
      this.visible = false;
    },
    //提交修改或添加
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          addYxdwUser(values)
              .then(res => {
                this.$ajaxAfter(res).then(() => {
                  this.$message.success("创建用户成功！");
                  this.setYxdwUser();
                  this.visible = false;
                });
              })
              .catch(() => {
                this.$message.error("服务器出错！请稍后再试!");
              });
        }
      });
    },
    setYxdwUser() {
      this.editStatus = false;
      getUnitUserList({...this.search})
          .then(res => {
            this.$ajaxAfter(res).then(() => {
              this.yxdwUserList = res.data.data.page.list;
            });
          })
          .catch(() => {
            this.$message.error("服务器出错！请稍后再试!");
          });
    },
    handleTableChange(page) {
      this.search.pageNum = page.current;
      this.initYxdwUserList();
    },
    getQyType(){
      getTypes("003006")
          .then(res => {
            this.$ajaxAfter(res).then(() => {
              this.regionMark = res.data.data.list;
            });
          })
          .catch(() => {
            this.$message.error("服务器出错！请稍后再试!");
          });
    },
    edit(record) {
      this.editItem = record;
      this.title = "修改机构用户：" + record.name;
      this.visible = true;
      this.editStatus = true;

      findYxdwList()
          .then(res => {
                this.$ajaxAfter(res).then(() => {
                  this.organizationList = res.data.data.list;
                })
              }
          );
      this.$nextTick(() => {
        console.log(this.organizationList)
        this.form2.setFieldsValue({
          name: record.name || "",

          mobile: record.mobile || "",
          yxdwId: record.yxdwId || "",
          yxdw: record.yxdw || "",
          dept: record.dept || "",
          station: record.station || "",
          userType: record.userType || "",
          sex: record.sex || "",
          region: record.region || undefined,
        });
      })
      //            setTimeout(() => {


      //            }, 0);
    },
    updateYxdwUser(e) {
      e.preventDefault();
      this.form2.validateFields((err, values) => {
        if (!err) {
          values.id = this.editItem.id;
          updateYxdwUser(values)
              .then(res => {
                this.$ajaxAfter(res).then(() => {
                  this.$message.success("修改成功！");
                  this.setYxdwUser();
                  this.visible = false;
                });
              })
              .catch(() => {
                this.$message.error("服务器出错！请稍后再试!");
              });
        }
      });
    },
    start(ids) {
      enableYxdwUser(ids)
          .then(res => {
            this.$ajaxAfter(res).then(() => {
              this.$message.success("启用成功！");
              this.setYxdwUser();
            });
          })
          .catch(() => {
            this.$message.error("服务器出错！请稍后再试!");
          });
    },
    stop(ids) {
      disableYxdwUser(ids)
          .then(res => {
            this.$ajaxAfter(res).then(() => {
              this.$message.success("禁用成功！");
              this.setYxdwUser();
            });
          })
          .catch(() => {
            this.$message.error("服务器出错！请稍后再试!");
          });
    },
    resetPass(mobile) {
      resetPassword(mobile)
          .then(res => {
            this.$ajaxAfter(res).then(() => {
              this.$message.success("重置密码成功！");
              this.setYxdwUser();
            });
          })
          .catch(() => {
            this.$message.error("服务器出错！请稍后再试!");
          })
    },
    compareIDCard(rule, value, callback) {
      let reg = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (value && !reg.test(value)) {
        callback('请输入正确的身份证号码');
      } else {
        callback();
      }
    },
    compareGDPhone(rule, value, callback) {
      let reg = /^(0[0-9]{2,3}-)?([2-9][0-9]{6,7})+(-[0-9]{1,4})?$/;
      if (value && !reg.test(value)) {
        callback('请输入正确的固定电话');
      } else {
        callback();
      }
    },
    async comparePhone(rule, value, callback) {
      this.checkFlag = "";
      let reg = /^(13[0-9]{9})|(14[0-9]{9})|(16[0-9]{9})|(19[0-9]{9})|(17[0-9]{9})|(15[0-9]{9})|(18[0-9]{9})$/;
      if (value && !reg.test(value)) {
        callback('请输入正确的手机号码');
        return;
      } else {
        let phone = value;
        let res = await axios.post(api + "/yxdw/checkPhone", qs.stringify({
              phone
            })
        );
        this.checkFlag = res.data.data.cflag;
        if (this.checkFlag === "false") {
          callback('该手机号已被注册');
        } else {
          callback();
        }
      }
    },
    async comparePhoneE(rule, value, callback) {
      this.checkFlag = "";
      let reg = /^(13[0-9]{9})|(14[0-9]{9})|(16[0-9]{9})|(19[0-9]{9})|(17[0-9]{9})|(15[0-9]{9})|(18[0-9]{9})$/;
      if (value && !reg.test(value)) {
        callback('请输入正确的手机号码');
      } else {
        let phone = value;
        let res = await axios.post(api + "/yxdw/checkPhone", qs.stringify({
              phone
            })
        );
        this.checkFlag = res.data.data.cflag;
        this.one = res.data.data.page;
        console.log(this.one.yxdwId);
        console.log(this.editItem.yxdwId);
      }
      if (this.checkFlag === "false" && this.one.yxdwId != this.editItem.yxdwId) {
        callback('该手机号已被注册');
      } else {
        callback();
      }
    },
  }
};
</script>

<style>
.search-box .ant-form-item-label {
  width: 65px;
  text-align: left;
}
</style>
<style scoped lang="less">
.f14 {
  font-size: 14px;
}

.search-box {
  .ant-form-item {
    display: inline-block;
    min-width: 280px;
  }

  .ant-select {
    width: 100%;
  }
}

.btns-group button {
  margin-right: 10px;
}

.submit-btn {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
}

//.ant-row > div {
//  height: 63px;
//}

.unitUser-list {
  margin-top: 30px;
}

.editable-row-operations a {
  margin-right: 10px;
}

.account-info {
  margin-bottom: 10px;
}

.auto-label {
  font-size: 14px;
}

.auth-list {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e8e8e8;
  padding: 10px 0;
}

.menu-top {
  flex-shrink: 0;
  width: 120px;
}

.menu-two-item {
  margin: 10px 0;
}

.menu-two-item {
  margin: 10px 0;
  display: flex;
  align-items: center;
}

.menu-two-top {
  width: 110px;
  flex-shrink: 0;
}

.operation-item {
  line-height: 28px;
}
</style>
